// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UzGda","col":"styles_col__66Fws"};